module.exports = __webpack_public_path__ + "static/media/CCTP -  Social Sciences Teacher_s Guide (v2).a72c7430.pptx";